(function () {
  var STORAGE_KEY = 'ssAppBannerDismissedUntil';
  var DISMISS_DAYS = 14;

  function isDismissed() {
    try {
      var until = window.localStorage.getItem(STORAGE_KEY);
      return until && Number(until) > Date.now();
    } catch (e) {
      return false;
    }
  }

  function rememberDismissal() {
    try {
      var until = Date.now() + DISMISS_DAYS * 24 * 60 * 60 * 1000;
      window.localStorage.setItem(STORAGE_KEY, String(until));
    } catch (e) {
      /* localStorage kapalıysa sessizce yok say */
    }
  }

  function detectPlatform() {
    var ua = window.navigator.userAgent || '';
    var isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
    var isAndroid = /Android/.test(ua);

    // iOS'ta Safari'yi ayırt et: Apple'ın kendi native "Smart App Banner"ı
    // zaten Safari'de gösteriliyor (theme.liquid'deki apple-itunes-app meta
    // etiketiyle), bu yüzden burada TEKRAR göstermiyoruz — sadece iOS'ta
    // Safari DIŞI bir tarayıcı (Chrome for iOS, Firefox for iOS vb.) varsa
    // kendi banner'ımızı gösteriyoruz, çünkü o tarayıcılarda native banner
    // desteklenmiyor.
    var isSafari = /^((?!chrome|android|crios|fxios|edgios).)*safari/i.test(ua);

    if (isAndroid) return 'android';
    if (isIOS && !isSafari) return 'ios';
    return null;
  }

  function init() {
    var banner = document.getElementById('smartAppBanner');
    if (!banner || isDismissed()) return;

    var platform = detectPlatform();
    if (!platform) return;

    var cta = banner.querySelector('[data-app-banner-cta]');
    var closeBtn = banner.querySelector('[data-app-banner-close]');

    if (cta) {
      cta.href = platform === 'android' ? banner.dataset.androidUrl : banner.dataset.iosUrl;
      cta.target = '_blank';
      cta.rel = 'noopener';
    }

    banner.hidden = false;
    banner.classList.add('is-visible');

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        banner.classList.remove('is-visible');
        banner.hidden = true;
        rememberDismissal();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
